// @ts-nocheck
import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";

import { Container } from "react-components";

import Seo from "../../components/seo";
import Layout from "../../components/layout";
import BlogMenu from "../../components/blogMenu";
import RichText from "../../components/contentful/richText";

import styles from "./author.css";

export default function Category({ data }) {
    return (
        <Layout background={"white"} footerBackground={"white"} navigation={"blog"}>
            <Seo
                title={data.contentfulPerson.name}
                description={data.contentfulPerson.name}
                meta={[{ name: `robots`, content: `noindex, nofollow` }]}
            />
            <Container size={"full"} className={styles.container}>
                <BlogMenu />
                <article className={styles.author}>
                    <div className={styles.header}>
                        {data.contentfulPerson.image && (
                            <GatsbyImage
                                alt={""}
                                className={styles.headerImage}
                                image={data.contentfulPerson.image.gatsbyImageData}
                            />
                        )}
                        <div>
                            <h1 className={styles.title}>{data.contentfulPerson.name}</h1>
                            {data.contentfulPerson.role && <p className={styles.role}>{data.contentfulPerson.role}</p>}
                        </div>
                    </div>
                    {data.contentfulPerson.about && <RichText content={data.contentfulPerson.about} />}
                </article>
            </Container>
        </Layout>
    );
}

Category.propTypes = {
    data: PropTypes.object,
};

export const query = graphql`
    query ($id: String!) {
        contentfulPerson(id: { eq: $id }) {
            id
            slug
            name
            role
            email
            twitter
            image {
                gatsbyImageData(layout: FULL_WIDTH, width: 400)
            }
            about {
                raw
            }
        }
    }
`;
